import { defaultUserImplementationSettings } from "../../../../components";
import { IUserImplementationSettings, useSettings } from "../../../../hooks";

const useUserImplementationSettings = (userGuid: string) => {
  const {
    userImplementationSettings: { [userGuid]: unsafeSettings },
    updateUserImplementationSettings,
  } = useSettings();

  const safeSettings: IUserImplementationSettings = {
    ...defaultUserImplementationSettings,
    ...unsafeSettings,
  };

  return {
    settings: safeSettings,
    updateSettings: (updatedSettings: Partial<IUserImplementationSettings>) => {
      updateUserImplementationSettings(userGuid, updatedSettings);
    },
  };
};

export { useUserImplementationSettings };
